import { useState, useEffect } from "react";

const useGetRecentlyAddedTradeIn = () => {
  const getUserToken = localStorage.getItem("userId");
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await fetch("/tradeindetails/recent", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Request failed");
        }

        const responseData = await response.json();
        setData(responseData);
      } catch (error) {
        setError(error.message);
      }

      setIsLoading(false);
    };

    fetchData();
  }, [getUserToken]);

  return { data, isLoading, error };
};

export default useGetRecentlyAddedTradeIn;
